<template>
  <div>
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation ref="navigation"></navigation>
    </div>
    <div class="sy_main">
      <div class="sy_position">您当前的位置：<router-link  :to="{ path: '/'}" >首页</router-link> &gt;&gt; 下载专区</div>
      <div class="sym_content2">
        <div class="symc2">

          <!--<div class="symc2_box">
            <div class="symc2_box_title"><img src="../assets/img/secondary_h3_pic.gif" width="21" height="15" /><a href="javascript:;">课件下载</a></div>
            <div class="symc2_box_main">
              <ul>
                <li><a href="" title="颈动脉系统闭塞的外科冶疗 ">颈动脉系统闭塞的外科冶疗 </a></li>
                <li><a href="" title="	资料整理中  ">	资料整理中  </a></li>
              </ul>
              <div class="sy_page"></div>
            </div>
          </div>-->

          <newsSimpleList :settings="downloadSettings"></newsSimpleList>
        </div>
        <!--右侧3竖模块-->
        <div class="symc_right">
          <login></login>
          <latestNewsSimple></latestNewsSimple>
        </div>
      </div>
      <div class=""></div>
    </div>
    <div style="width: 1002px;margin: 0 auto">
      <footer1></footer1>
    </div>
  </div>
</template>

<script>
  import {getRecommendList} from '../api/api';
  import  header2 from '../components/Header2'
  import  latestNewsSimple from '../components/LatestNewsSimple'
  import  navigation from '../components/Navigation'
  import  footer1 from '../components/Footer1'
  import  login from '../components/Login'
  import  newsSimpleList from '../components/NewsSimpleList'
  import  perfectCourseSimpleList from '../components/PerfectCourseSimpleList'
  import  medicalDynamicNews from '../components/MedicalDynamicNews'
  export default {
    components: {
      header2,
      footer1,
      navigation,
      login,
      newsSimpleList,
      latestNewsSimple,
      medicalDynamicNews
    },
    data () {
      return {
        downloadSettings: {
          consultName:'文件下载',
          consultId: 51,
          publishState: 0,
          publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
          'orderWeight': true,
          orderPublishTime: true,
          pageNum: 1,
          pageSize: 30,
        },
        secondCarousel: null
      }
    },
    mounted () {
      document.getElementById("J_GotoTop").style.visibility="hidden";//隐藏在线客服
    },
    destroyed () {
      document.getElementById("J_GotoTop").style.visibility="visible" //显示在线客服
    },
    computed: {},
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .symc2_box_main ul li a.xiazai{display: block; text-align: right; font-size: 12px;position: absolute; top:0; right: 8px;width:100px;background: none; text-align: right;}
</style>



// WEBPACK FOOTER //
// src/views/DownLoad.vue